import * as axios from "axios";
import { getAuthHeader, removeAllCookies } from "../utils";

export const addDak = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}dak-management/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);
    }
  );
};

export const getDakListAdmin = () => {
  const url = `${process.env.REACT_APP_BASE_URL}dak-management/dak-list`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);
    }
  );
};

export const generateCode = (type) => {
  const url = `${process.env.REACT_APP_BASE_URL}dak-management/generate-code/${type}`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const getListExec = () => {
  const url = `${process.env.REACT_APP_BASE_URL}dak-management/list-exec`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);
    }
  );
};

export const getListDesk = () => {
  const url = `${process.env.REACT_APP_BASE_URL}dak-management/list-desk`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);
    }
  );
};

export const confirmReceived = (id) => {
  const url = `${process.env.REACT_APP_BASE_URL}dak-management/confirm-received/${id}`;
  return axios.put(url, {}, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);
    }
  );
};

export const confirmDispatched = (payload, id) => {
  const url = `${process.env.REACT_APP_BASE_URL}dak-management/confirm-dispatched/${id}`;
  return axios.put(url, payload, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);
    }
  );
};
